import {
  HistoryOutlined,
  IdcardOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

const CustomerSidebar = ({ driverId }: any): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu
            // defaultSelectedKeys={["0"]}
            mode="inline"
          >
            <Menu.Item
              key="/details"
              className={pathname.includes("details") ? "active" : ""}
              icon={<IdcardOutlined />}
            >
              <Link to={`/drivers/${driverId}/details`}>Basic Information</Link>
            </Menu.Item>

            <Menu.Item
              key="/unsettle-orders"
              icon={<HistoryOutlined />}
              className={pathname.includes("/unsettle-orders") ? "active" : ""}
            >
              <Link to={`/drivers/${driverId}/unsettle-orders`}>
                Unsettle Orders
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/orders"
              icon={<ShoppingCartOutlined />}
              className={pathname.includes("/orders") ? "active" : ""}
            >
              <Link to={`/drivers/${driverId}/orders`}>Order History</Link>
            </Menu.Item>

            <Menu.Item
              key="/transactions"
              icon={<SolutionOutlined />}
              className={pathname.includes("/transactions") ? "active" : ""}
            >
              <Link to={`/drivers/${driverId}/transactions`}>
                Transaction History
              </Link>
            </Menu.Item>
            <Menu.Item
              key="/locationhistory"
              icon={<SolutionOutlined />}
              className={pathname.includes("/locationhistory") ? "active" : ""}
            >
              <Link to={`/drivers/${driverId}/locationhistory`}>
                Location History
              </Link>
            </Menu.Item>
            {/* <Menu.Item
              key="/cash-collect"
              icon={<WalletOutlined />}
              className={pathname.includes("/cash-collect") ? "active" : ""}
            >
              <Link to={`/drivers/${driverId}/cash-collect`}>Collect Cash</Link>
            </Menu.Item> */}
          </Menu>
        </div>
      </div>
    </>
  );
};

export default CustomerSidebar;
